import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { PersonInfo, UserGroup, UserInfos, GraphUser, UserAccessRole } from '../../shared/models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService } from 'primeng/api';
import { UserService } from '../../shared/services/user.service';
import { AppComponent } from '../../app.component';
import { Message, MessageActionType, MessageType, AppComponentName } from '../../shared/models/Messages/message.model';
import { AppMessageService } from '../../shared/services/message.service';
import { CommonShared } from 'app/shared/classes/common';
import { Authorization } from 'app/shared/classes/authorization';
import { ChangeLogNotesParams, ChangeLogNotesComponent } from '../messages/changelog-notes/changelognotes.components';


@Component({
  standalone: false,
  selector: 'app-user-groups',
  templateUrl: './user-groups.component.html',
  styleUrls: [ './user-groups.component.scss' ]
})

export class UserGroupsComponent implements OnInit {
  public common = new CommonShared();
  public auth = new Authorization();

  modalDragOn: boolean = false;

  public userGroups: UserGroup[] = [];
  public associatedUserGroups: UserGroup[] = [];
  public awaitUserGroups = false;
  public awaitAssociatedUserGroups = false;
  public userInfos: GraphUser[] = [];
  public lastName = '';
  public userGroupTitle: string;
  public username = 'unknown';
  public buttonValue: string;
  public userTitle: string;
  public userGroup: UserGroup;
  public user: PersonInfo;
  public preEditObjectAsJSONString = '';
  public changeLogNotes = '';
  public userEdited: boolean = false;
  public duplicateName: boolean = false;

  public userGroupCols = [
    {field: 'name', header: 'Name', width: '25%'},
    {field: 'description', header: 'Description', width: '30%'},
    {field: 'lastModifiedDate', header: 'Modified Date', width: '25%'},
    {field: 'members', header: 'Members', width: '10%'},
    {field: 'edit', header: '', width: '5%'},
    {field: 'delete', header: '', width: '5%'}
  ];

  public userCols = [
    {field: 'name', header: 'User Name', width: '50%'},
    {field: 'role', header: 'Role', width: '40%'},
    {field: 'delete', header: '', width: '10%'}
  ];

  public adUserCols = [
    {field: 'displayName', header: 'Display Name', width: '24%'},
    {field: 'mail', header: 'Email', width: '36%'},
    {field: 'givenName', header: 'First', width: '14%'},
    {field: 'surname', header: 'Last', width: '16%'},
    {field: 'add', header: '', width: '10%'}
  ];

  public UserRolesDDOptions: string[] = [ 'GroupFullRW', 'GroupLimitedRW', 'GroupReadOnly', 'ViewListing' ];

  logModalRef: BsModalRef;
  modalRef: BsModalRef;
  userModalRef: BsModalRef;

  config = {
    backdrop: false,
    ignoreBackdropClick: false
  };

  userconfig = {
    backdrop: false,
    ignoreBackdropClick: false,
    class: 'gray modal-lg'
  };

  public userNameTimer: any;
  public globalSwitch: boolean;

  constructor(public toastr: ToastrService, public modalService: BsModalService, private confirmationService: ConfirmationService,
              public _userService: UserService, private global: AppComponent, public _appMessageService: AppMessageService,
              private route: ActivatedRoute) {
                this.globalSwitch = global.globalSwitch;
                this.linkedSearch = route.snapshot.queryParamMap.get('search');
               }


  public userGroupSearchText = '';

  // Search text passed in by a link (e.g. from the home page search). The table only exists once its
  // data has loaded, so the text is applied when the table appears.
  private linkedSearch: string | null = null;

  @ViewChild('userGroupTable') set userGroupTableRef(table: Table | undefined) {
    if (table == undefined || this.linkedSearch == null) return;

    const text = this.linkedSearch;
    this.linkedSearch = null;
    // Deferred so the search box's value is not changed in the middle of a change-detection pass
    setTimeout(() => {
      this.userGroupSearchText = text;
      table.filterGlobal(text, 'contains');
    });
  }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {

        this.username = results['value'];
        if (this.username != null && this.username != '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
    //this.getUserGroups();
    this.getAssociatedUserGroups();
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  getUsersByLastName(): void {
    this._userService.getUserByLastNameAzureAD(this.lastName).subscribe(
      results => {
        if (results != null) {
          this.awaitUserGroups = true;
          this.userInfos = results['value'];

          // this.userInfos.forEach(u => {
          //   u.mail = (u.mail.includes('@')) ? u.mail.split('@')[0] + "@corteva.com" : u.mail;
          // });
        }
        else {
          this.toastr.warning('No users found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving search list');
      });
  }


  getUserGroups(): void {
    this._userService.getUserGroups().subscribe(
      results => {
        if (results != null) {
          this.awaitUserGroups = true;
          this.userGroups = results;

          var adminsGroup = this.userGroups.find(x => x.name.toLowerCase() == 'admins');
          if (adminsGroup != undefined) {
            this.buildUserList(adminsGroup);
            this.auth.mapUserAccessForUserGroup(adminsGroup, this.globalSwitch, this.username, adminsGroup);
          }
          else {
            this.toastr.warning('Admins group does not exist. Please before creating other groups.');
          }

          this.userGroups.forEach(g => {
            if (g.name.toLowerCase() != 'admins') {
              //this.updateUserInfoRoles(g);
              this.buildUserList(g);
              this.auth.mapUserAccessForUserGroup(g, this.globalSwitch, this.username, adminsGroup);
            }
          });
        }
        else {
          this.toastr.warning('No User Groups found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  getAssociatedUserGroups(): void {
    this._userService.getAssociatedUserGroups(this.username).subscribe(
      results => {
        if (results != null) {
          this.awaitAssociatedUserGroups = true;
          this.associatedUserGroups = results;
          this.getUserGroups();
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving current display.');
      });
  }


  onDeleteUserGroupConfirm(userGroup) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this User Group?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this._userService.deleteUserGroup(userGroup.id).subscribe(
          results => {
            if (results != null) {
              this.createMessageData(MessageActionType.Deleted, userGroup, '');
              this._userService.clearCachedVariables();
              this.getAssociatedUserGroups();
              this.toastr.success('Success');
            } else {
              this.toastr.warning('No User Groups found.');
            }
            return;
          },
          err => {
            this.toastr.error('Error occurred while deleting User Group.');
          });
      },
      reject: () => {
      }
    });
  }


  buildUserList(userGroup: UserGroup) {
    userGroup.userList = '';
    if (userGroup.userInfos == undefined) return;

    userGroup.userInfos.forEach(g => {
      if (g.role == undefined) g.role = UserAccessRole.GroupRead;
      userGroup.userList += g.userName.split('@')[0] + ' (' + g.role.toString() + ')' + '\n'
    });
  }


  onDeleteUserConfirm(user: UserInfos) {
    this.userGroup.userInfos.forEach((item, index) => {
      if (item.id === user.id) {
        this.userGroup.userInfos.splice(index, 1);
      }
    });
  }


  addUserGroup(template: TemplateRef<any>) {
    this.buttonValue = 'Create';
    this.userGroup = {} as UserGroup;
    this.userGroup.userInfos = [];
    this.userGroupTitle = 'New User Group';
    this.userGroup.id = 0;
    this.userEdited = false;
    const user = {id: 0, userName: this.username};
    this.userGroup.userInfos.push(user);
    this.modalRef = this.modalService.show(template, this.config);
  }


  addUser(template: TemplateRef<any>) {
    this.lastName = '';
    this.userInfos = [];
    this.userTitle = 'New User';
    //this.user = {} as PersonInfo; // TODO: this is a bad way of expressing this
    this.user = { username: '', firstname: '', lastname: '', displayname: '', email: '' };
    this.userModalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true });
  }


  addAdUser(adUser: GraphUser) {
    const user = {id: 0, userName: adUser.mail};
    this.userGroup.userInfos.push(user);
    this.userModalRef.hide();
  }


  updateUserGroup(): void {
    if (this.duplicateNamecheck(this.userGroup.name)) {
      return;
    }

    if (this.userGroup.id < 1) {
      this.onCreate(this.userGroup);
    } else {
      this.onEdit(this.userGroup);
    }
  }


  onCreate(userGroup: UserGroup) {
    if (userGroup.name === '' || userGroup.description === '' || userGroup.userInfos.length < 1) {
      this.toastr.error('Please include all the required parameters');
    } else if (this.userGroups.findIndex(g => g.name === userGroup.name) > -1) {
      this.toastr.error('This User Name already exists');
    } else {
      this.modalRef.hide();
      this._userService.createUserGroup(userGroup).subscribe(
        results => {
          if (results != null) {
            this.createMessageData( (userGroup.id < 1) ? MessageActionType.New : MessageActionType.New, userGroup, '');
            this._userService.clearCachedVariables();
            this.getAssociatedUserGroups();
            this.buildUserList(userGroup);
            this.toastr.success('Success: ' + userGroup.name + ' created');
          } else {
            this.toastr.warning('Not found.');
          }
          return;
        },
        err => {
          this.toastr.error('Error occurred while adding user group');
        });
    }
  }


  onEdit(userGroup: UserGroup) {
    this.userGroups.forEach((s) => {
      if (s.name === userGroup.name && s.id !== userGroup.id) {
        this.toastr.error('The user group name already exists');
        return;
      }
    });

    if (userGroup.name === '' || userGroup.description === '' || userGroup.userInfos.length < 1) {
      this.toastr.error('Please include all the required parameters');
    } else {
      this.modalRef.hide();
      this._userService.updateUserGroup(userGroup).subscribe(
        results => {
          if (results != null) {
            this.createMessageData( (userGroup.id < 1) ? MessageActionType.New : MessageActionType.Edited, userGroup,
              (MessageActionType.Edited) ? this.getEditChanges(userGroup) : '');
            this._userService.clearCachedVariables();
            this.getAssociatedUserGroups();
            this.buildUserList(userGroup);
            this.toastr.success('Success: ' + userGroup.name + ' updated');
          } else {
            this.toastr.warning('No user groups found');
          }
          return;
        },
        err => {
          this.toastr.error('Error occurred while updating user group');
        });
    }
  }


  editUserGroup(userGroup: UserGroup, template: TemplateRef<any>) {
    this.buttonValue = 'Update';
    this.userGroup = userGroup;
    this.userGroupTitle = userGroup.name;
    this.userEdited = false;
    if (this.userGroup.userInfos != undefined) {
      this.userGroup.userInfos.forEach(u => u.changed == false);
    }
    this.preEditObjectAsJSONString = JSON.stringify(userGroup);
    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true })
  }


  createMessageData(msgActionType: MessageActionType, userGroup: UserGroup, msgNote: string) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.UserGroups,
      actionType: msgActionType,
      appComponentItem: userGroup.name,
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: null
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  getEditChanges(userGroup: UserGroup): string {
    let results = '';

    if (this.preEditObjectAsJSONString !== '') {
      const original: UserGroup = JSON.parse(this.preEditObjectAsJSONString);
      results += this.common.compareProperty('Name', original.name, userGroup.name);
      results += this.common.compareProperty('Enable', this.common.prepareProperty4String(!original.isdisabled), this.common.prepareProperty4String(!userGroup.isdisabled));
      results += this.common.compareProperty('Description', original.description, userGroup.description);
      results += this.common.compareProperty('Status', original.status, userGroup.status);
      results += this.common.compareProperty('UserCount', original.userInfos.length.toString(), userGroup.userInfos.length.toString());
      results += this.compareUserInfos(original.userInfos, userGroup.userInfos);
    }

    return results;
  }


  compareUserInfos(origUserInfos: UserInfos[], newUserInfos: UserInfos[]): string {
    var results: string = '';
    if (newUserInfos == undefined) return results;

    newUserInfos.forEach(u => {
      var userInfo = origUserInfos.find(o => o.id == u.id);
      if (userInfo != undefined) {
        if (userInfo.role != u.role) {
          results += 'Role for ' + u.userName + ' (' + userInfo.role + ' -> ' + u.role + '),  ';
        }
      }
    });
    return results;
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';

    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }
  

  updateUserDetails(userInfo: UserInfos) {
    userInfo.changed = true;
    this.userEdited = true;
  }


  duplicateNamecheck(name: string): boolean {
    this.duplicateName = false;
    this.userGroups.forEach(x => {
      if (x.name.toLowerCase() == name.toLowerCase() && x.id != this.userGroup.id){
        this.toastr.error('User group name is already in use');
        this.duplicateName = true;
        return this.duplicateName;
      }
    });
    return this.duplicateName;
  }

}
